import React from "react";
import PropTypes from "prop-types";
import { DecisionComponent } from "../../steps/components/DecisionComponent/Decision.component";
import {withNamespaces} from "react-i18next";
import CancelForm, {CancellationReasons} from "../models/CancelForm";
import InputGroup from "../../forms/components/InputGroup/InputGroup";

const CancellationReasonComponent = (props) => {
  const {t} = props;
  const cancellationData = props.data.cancellation || new CancelForm();

  const handleChange = (name, value) => {
    const data = new CancelForm({
      ...cancellationData,
      [name]: value,
    });
    props.setData({cancellation: data});
  };

  return (
    <div className='cancellation-reason-component'>
      <div className='cancellation-process-header'>
        <p className='bold'>{t('member_cancellation_header')}</p>
        <p className='bold'>{t('member_cancellation_header2')}</p>
      </div>

      <DecisionComponent step={props.step} selectedStep={props.selectedStep} onStepSelect={props.onStepSelect} />
      {(
        <div className={`form-group expandable${!props.selectedStep || props.selectedStep.name !== CancellationReasons.Other ? ' not-shown' : ''}`}>
          <InputGroup id={'cancellation-offer-comment'} label={t('member_cancellation_other_reason_label')} topLabel={true}>
            <input placeholder={t('member_cancellation_other_reason_label')} type="text"
                   value={cancellationData.reason || ''} onChange={e => handleChange('reason', e.target.value)}/>
          </InputGroup>
        </div>
      )}
    </div>
  );
};

CancellationReasonComponent.propTypes = {
  step: PropTypes.object.isRequired,
  selectedStep: PropTypes.object,
  onStepSelect: PropTypes.func,
  setData: PropTypes.func,
  data: PropTypes.object,
};

export default withNamespaces()(CancellationReasonComponent);